import { render } from "./LogsTab.vue?vue&type=template&id=46d62dd0&scoped=true"
import script from "./LogsTab.vue?vue&type=script&lang=js"
export * from "./LogsTab.vue?vue&type=script&lang=js"

import "./LogsTab.vue?vue&type=style&index=0&id=46d62dd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d62dd0"]])

export default __exports__